import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a5995415dd08a0014be9f4f_1784512061091_c0c719da/pueblamapcam/src/app/alertas/page.tsx");
